export default "/app/62d9dae4e0040e81c980950003df0e07.svg";